import React, { Component } from 'react';

import CaselyLogo from '../images/caselyLogo.png';

import './../styles/logo.css';

interface IState {
    navigatorURL: string;
}

class Logo extends Component<{}, IState> {
    constructor(props: any) {
        super(props);

        this.state = {
            navigatorURL: document.getElementById('navigatorURL').value
        };
    }

    getAPI = () => {
        let apiURL = JSON.parse(localStorage.getItem('api'));
        
        //this.setState({
        //    navigatorURL: apiURL.navigatorUrl
        //});

    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('load-trigger', this.getAPI);
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('load-trigger', this.getAPI);
        }
    }

    public render() {
        return (
            <div className='search-logo'>
                <a href={this.state.navigatorURL} target="_parent">
                    <img src={CaselyLogo} />
                </a>
            </div>
        );
    }
}

export default Logo;